import React from 'react';
import { IntlFormatters, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Tag } from '@xingternal/tag';

import { useBreakpoints } from '@/hooks';

const Highlight = styled.span`
  font-weight: 700;
  filter: grayscale(100%) contrast(300%);
`;

const getTagTitle = (formatMessage: IntlFormatters['formatMessage'], category: string): string => {
  switch (category) {
    case 'keywords':
    case 'location':
      return formatMessage({ id: `SE_SUMMARY_JOBS_${category.toUpperCase()}_LABEL` });
    default:
      return formatMessage({ id: `SE_FILTER_JOBS_${category.toUpperCase()}_LABEL` });
  }
};

type Props = {
  name: string;
  value: string;
};

export const SummaryTag: React.VFC<Props> = ({ name, value }) => {
  const { formatMessage } = useIntl();
  const { isDesktop } = useBreakpoints();

  return (
    <Tag value={value} maxWidth={isDesktop ? '516px' : '238px'}>
      {getTagTitle(formatMessage, name)}
      <Highlight>{`: ${value}`}</Highlight>
    </Tag>
  );
};
